import { Directive, ElementRef } from "@angular/core";

@Directive({
    selector: "[dir-autofocus]",
})
export class AutoFocusDirective {
    constructor(private el: ElementRef<HTMLInputElement>) {}

    ngAfterViewInit() {
        setTimeout(() => this.el.nativeElement.focus());
    }
}
